/*
 * loginReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Pietro
 * @since 13-Sep-2024
 */

import { produce } from 'immer'
import { actionTypes } from 'Store/actions/login'
import { nullSafe } from 'Utility/globalMethods'

const ACTION_HANDLERS = {
  [actionTypes.GET_TOKEN_FAILURE]: produce((draft) => {
    draft.isCredentialsInvalid = true
  }),
  [actionTypes.GET_TOKEN_SUCCESS]: produce((draft) => {
    draft.isCredentialsInvalid = false
  }),
  [actionTypes.GET_TOKEN_REQUEST]: produce((draft) => {
    draft.isCredentialsInvalid = false
  }),
  [actionTypes.GET_CARDHOLDER_NAME_SUCCESS]: produce((draft, action) => {
    draft.userInfoFromCookie = nullSafe(() => action.response.userInfoFromCookie, {})
  }),
  [actionTypes.DO_RESET_CARDHOLDER_NAME]: produce((draft) => {
    draft.userInfoFromCookie = {}
  }),
  [actionTypes.IAM_LOGIN_SUCCESS]: produce((draft, action) => {
    draft.errorCode = nullSafe(() => action.payload.errorCode, '')
  }),
  [actionTypes.DO_RESET_IAM_LOGIN_ERROR]: produce((draft) => {
    draft.errorCode = initialState.errorCode
  }),
  [actionTypes.ROPC_TOKEN_FAILURE]: produce((draft, action) => {
    draft.errorCode = nullSafe(() => action.error.data.error, '')
  }),
  [actionTypes.GET_LOGIN_NEWS_SUCCESS]: produce((draft, action) => {
    draft.news = nullSafe(() => action.response.messages, [])
  })
  // @generator reducer:type:action
}

// The initial state of the login
const initialState = {
  isCredentialsInvalid: false, // TODO possiamo eliminarlo?
  rememberedName: '',
  errorCode: '',
  extendSessionUrl: '',
  pathToRedirect: '',
  news: []
}

const login = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler
    ? handler(state, action)
    : state
}

export default login
